import { DateTime } from "luxon";

export function maskPercent(paramNumber) {
  return new Intl.NumberFormat("pt-BR", {
    style: "percent",
    minimumFractionDigits: 2,
  }).format(paramNumber);
}

export function maskCurrency(paramNumber) {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(Number(paramNumber));
}

export function maskDate(date) {
  if(date && date != '') {
    let formatedDate = date;
    if (!date?.includes('T')) {
      if (date?.includes(' '))
        formatedDate = date?.replace(' ', 'T');
    };

    return DateTime.fromISO(formatedDate).setLocale('pt-BR').toLocaleString(DateTime.DATE_SHORT);
  }
  return '';
}

export function extractFromDateYearMonth(dataString) {
  const ano = dataString?.substring(0, 4);
  const mes = dataString?.substring(4, 6);
  return new Date(`${ano}-${mes}-01`);
}

export function maskDateYearMonth(dataString) {
  const data = extractFromDateYearMonth(dataString)
  const options = { month: 'short', year: 'numeric' }; // long, short, numeric, 2-digit'
  const formatter = new Intl.DateTimeFormat('pt-BR', options, );

  return formatter.format(data)
    .replace('. de ', '/');
}

export function maskDateTime(date) {
  if (date && date != '') {
    let formatedDate = date;
    if (!date?.includes('T')) {
      if (date?.includes(' '))
        formatedDate = date?.replace(' ', 'T');
    };

    return DateTime.fromISO(formatedDate).setLocale('pt-BR').toLocaleString(DateTime.DATETIME_SHORT);
  }
  return '';
}

export const removeMask = (value) => (value.length > 0 ? value.replaceAll(/[^0-9]/g, "") : value);

export function maskCpf(cpf) {
  if (cpf) {
    let cpfFormatado = cpf.replace(/\D/g, '');
    cpfFormatado = cpfFormatado.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    return cpfFormatado;
  }

  return '';
}

export const FormatDate = (date) => {
  if (date == null) return '';

  const dateFormat = DateTime.fromFormat(date, 'yyyy-MM-dd');
  return dateFormat.toLocaleString(DateTime.DATE_SHORT);
}
